// Cross-page theme persistence (localStorage-backed).
// Pages do:
//   const [t, setTweak] = useTweaks(mergeDefaults({ theme: 'paper', ... }));
// so toggling theme/density/variant on one page survives navigation.

const KEY = 'xelence-tweaks-v2';

type Tweaks = Record<string, unknown>;

function load(): Tweaks {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '{}') || {};
  } catch {
    return {};
  }
}

function save(obj: Tweaks): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(obj));
  } catch {
    /* noop */
  }
}

export function mergeDefaults<T extends Tweaks>(defaults: T): T {
  return { ...defaults, ...load() } as T;
}

export function persistTweak(key: string, val: unknown): void {
  save({ ...load(), [key]: val });
}
